import classNames from 'classnames';
import { v4 as uuidv4 } from 'uuid';

import Input from 'atoms/input';
import TypeaheadInput from 'atoms/typeahead';
import useWindowDimensions from 'hooks/useWindowDimensions';

export default function AppointmentItemType({
  item,
  options,
  onChange,
  focus,
}) {
  const { width } = useWindowDimensions();
  const isMobileOrTablet = width <= 1366;

  const onMobileOrTabletChange = (event) => {
    const selectedService = JSON.parse(event?.target?.value);
    onChange(selectedService);
  };

  return item.isCustomItem ? (
    <Input
      variant="white"
      size="small"
      className="custom-item-input"
      onChange={(value) => onChange(value)}
      value={item.value}
    />
  ) : isMobileOrTablet ? (
    <select
      defaultValue={JSON.stringify(
        options.find((option) => option.uuid === item.uuid)
      )}
      onChange={onMobileOrTabletChange}
      className="mobile-tablet-service-select"
    >
      {options.map((option) => {
        const value = JSON.stringify(option);
        return <option value={value}>{option.name}</option>;
      })}
    </select>
  ) : (
    <TypeaheadInput
      className={classNames(focus && 'service-item--focus')}
      id={item.uuid}
      items={options}
      labelKey="name"
      placeholder="Type a service"
      onChange={(option) => onChange(option[0] || { uuid: uuidv4() })}
      item={!item?.name ? [] : [{ name: item.name, uuid: item?.uuid }]}
    />
  );
}
